import React, { Component } from 'react'
import { Subscribe } from 'unstated'

import QuestionBankStore from '../../store/QuestionBankStore'
import UserResponseStore from '../../store/UserResponseStore'
import { getQuestionBankProgress } from '../../store/selectors'

import { getBoxSplit } from '../../module/utils'
import ProgressBar from '../_presentational/ProgressBar/ProgressBar'

class QuestionBankProgressBar extends Component {
  render() {
    const { questionBankProgress } = this.props
    const { questionCount, boxSpread } = questionBankProgress
    const boxSplit = getBoxSplit({ boxSpread })
    return (
      <ProgressBar
        height="12px"
        targetColor="whitesmoke"
        target={questionCount}
        split={boxSplit}
        animateOnEntry
        animateSeconds="0.5"
      />
    )
  }
}

export default props => {
  return (
    <Subscribe to={[QuestionBankStore, UserResponseStore]}>
      {(questionBank, userResponse) => {
        const questionBankProgress = getQuestionBankProgress({
          questionBankState: questionBank.state,
          userResponseState: userResponse.state,
          questionBankId: props.questionBankId,
        })
        return <QuestionBankProgressBar {...props} questionBankProgress={questionBankProgress} />
      }}
    </Subscribe>
  )
}



// WEBPACK FOOTER //
// ./src/component/QuestionBankProgressBar/QuestionBankProgressBar.jsx